// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2gxqO","name":"ConsentHeader_name__28u-G","birthday":"ConsentHeader_birthday__2C2aX","skeleton":"ConsentHeader_skeleton__NStXX"};